module.exports = __webpack_public_path__ + "static/media/logoInfra.be32c459.png";